/*eslint-disable no-constant-condition */
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import store from './redux/store';
import { injectStore } from './api/axios';
import { injectStoreWithTimeout } from './api/axiosWithTimeout';
import AdminRoutes from './Router/AdminRoutes';
import MemberRoutes from './Router/MemberRoutes';
import LandingPageRoute from './Router/LandingPageRoute';

import './services/i18n';
import Startup from './Startup';
import HttpHeader from 'src/Member/shared/httpheader';

injectStore(store);
injectStoreWithTimeout(store);

const persistor = persistStore(store);

export default function App() {
  const cName = HttpHeader.getCNAME();
  if (cName.includes('mybenefits') || cName.includes('roundstone')) {
    document
      .getElementById('favicon')
      .setAttribute(
        'href',
        `https://${HttpHeader.getCNAME()}.${HttpHeader.getDomainName()}/RoundstoneFavicon.png`,
      );
  } else if (cName.includes('keenan') || cName.includes('tpabenefits')) {
    document
      .getElementById('favicon')
      .setAttribute(
        'href',
        `https://${HttpHeader.getCNAME()}.${HttpHeader.getDomainName()}/keenanfavicon.svg`,
      );
  } else if (cName.includes('hub')) {
    document
      .getElementById('favicon')
      .setAttribute(
        'href',
        `https://${HttpHeader.getCNAME()}.${HttpHeader.getDomainName()}/hubfavicon.png`,
      );
  } else {
    document
      .getElementById('favicon')
      .setAttribute(
        'href',
        `https://${HttpHeader.getCNAME()}.${HttpHeader.getDomainName()}/favicon.ico`,
      );
  }

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          {/*<Suspense fallback={null} > */}
          <Startup />

          <div className="landing-page">
            <LandingPageRoute />
          </div>
          <div className="admin">
            <AdminRoutes />
          </div>
          <div className="member">
            <MemberRoutes />
          </div>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}
